import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldSelect({ field, action, value, handleChange, hasChanged }) {
  console.log(`AppObjectFieldYesNo rendered: ${field.name}`, value)

  if (isDisabled(action, field.behaviorType)) {
    let displayString = ''
    if (value === 'Y') {
      displayString = 'Yes'
    } else if (value === 'N') {
      displayString = 'No'
    }
    return (<span>{displayString}</span>)
  }
  return (
    <Input
      data-cy={`field-${field.id}`}
      type="select"
      name={field.id}
      bsSize="sm"
      style={{ width: 'auto' }}
      id={field.id}
      value={value}
      onChange={(event) => handleChange(event, hasChanged)}
    >
      <option value={'Y'}>Yes</option>
      <option value={'N'}>No</option>
    </Input>
  )
}
